//? Generate proper menu links from navigation API data
// From: https://www.pailottery.com/ and /promotions
// To: https://www.pailottery.com/promotions

export const generateNavURL = (url, portalUri) => {
    if (!url) return '';

    const isExternalUrl = new RegExp('^(http|https)://');
    if(!isExternalUrl.test(url)) {
        const statsWithSlash = new RegExp('^/');
        return portalUri + (statsWithSlash ? url.substring(1) : url);
    }
    return url;
};
